<template>
  <v-card outlined>
    <v-row no-gutters>
      <v-menu
        v-for="({ property, text, value }, index) in dates"
        :key="property"
        v-model="dates[index].display"
        :close-on-content-click="false"
        offset-y
        nudge-bottom="10"
      >
        <template v-slot:activator="{ on }">
          <v-col cols="12" sm="6">
            <v-btn
              v-on="on"
              :disabled="disabled"
              text
              block
              class="caption font-weight-medium grey--text text--darken-3 text-truncate"
              max-width="100%"
            >
              {{ `${text} ${inputDates[value]}` }}
            </v-btn>
          </v-col>
        </template>
        <v-date-picker
          :value="inputDates[value]"
          @input="checkBeforeUpdate(property, $event)"
          @change="dates[index].display = false"
          :locale="language"
          :min="initialDateEnv"
          :max="maxDate"
          :type="datePickerType"
          no-title
          color="#2661FF"
        />
      </v-menu>
    </v-row>
  </v-card>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import { mapState } from "vuex";
import Vue from "vue";
export default {
  name: "DateFilters",
  props: {
    disabled: { type: Boolean },
    initialDate: {
      type: String,
      default: () => this.$moment().format("YYYY-MM-DD"),
      required: true
    },
    finalDate: {
      type: String,
      default: () => this.$moment().format("YYYY-MM-DD"),
      required: true
    },
    minDate: {
      type: String,
      default: "",
      required: false
    },
    datePickerType: {
      type: String,
      default: "date",
      required: false
    }
  },
  data() {
    return {
      initialDateEnv: process.env.INITIAL_DATE || "2015-01-01",
      dates: [
        {
          property: "initialDate",
          text: this.$t("dates.from"),
          value: "initialDate",
          menu: false
        },
        {
          property: "finalDate",
          text: this.$t("dates.until"),
          value: "finalDate",
          menu: false
        }
      ],
      maxDate: this.$moment().format("YYYY-MM-DD"),
      startOfMonth: this.$moment()
        .startOf("month")
        .format("YYYY-MM-DD")
    };
  },
  computed: {
    ...mapState({
      lang: ({ auth: { locale } }) => locale,
      creationDateOrg: ({ auth: { user } }) => user.organization.created_at
    }),
    inputDates() {
      return {
        initialDate: this.initialDate,
        finalDate: this.finalDate
      };
    },
    minimumDate() {
      if (!this.minDate) {
        const creationDateOrg = this.$moment(this.creationDateOrg).format(
          "YYYY-MM-DD"
        );
        const oneYearAgo = this.$moment()
          .subtract(1, "year")
          .add(1, "day")
          .startOf("day")
          .format("YYYY-MM-DD");
        return creationDateOrg < oneYearAgo ? creationDateOrg : oneYearAgo;
      }
      return this.minDate;
    },
    language() {
      const { lang } = this;
      if (lang === "es" || lang === "es_ca") {
        return "es-mx";
      }
      if (lang === "en") {
        return "en-us";
      }
      return "pt-br";
    }
  },
  methods: {
    checkBeforeUpdate(property, value) {
      if (property === "initialDate") {
        if (value > this.finalDate) {
          this.$noty.error(this.$t("dates.invalid_range"));
        } else if (value !== this.initialDate) {
          this.$emit("updateInitialDate", value);
        }
      } else if (value < this.initialDate) {
        this.$noty.error(this.$t("dates.invalid_range"));
      } else if (value !== this.finalDate) {
        this.$emit("updateFinalDate", value);
      }
    }
  }
};
</script>

<style></style>
